 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		84: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"TwitterIcon","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"components-not_found_component-not_found_component","19":"components-slug-slug","20":"customCollectionPage","21":"feed","22":"loginPage","23":"logoutPage","24":"magazineTagPage","25":"magazine_page","26":"myAccountPage","27":"newsletters_page_marketo","28":"notFoundPage","29":"offerPage","30":"playlistIndexPage","31":"playlistPage","32":"podcastPage","33":"post_page","34":"registerPage","35":"resetPasswordPage","36":"sitemapIndex","37":"sitemapPost","38":"stories","39":"subscribePage","40":"tagPage","41":"videoIndex","42":"videoPage","43":"views-containers-layouts-blank_layout-blank_layout","44":"views-containers-layouts-web_layout-web_layout","79":"MarketoNewsletterForm","80":"MicCarousel","81":"MicIcon","82":"MicMobileIconCarousel","83":"Success-SubmissionSuccess","85":"applications-most-innovative-companies","86":"brands_that_matter_2021","87":"brands_that_matter_page","88":"categoryLink","89":"components-BackgroundHighlight-BackgroundHighlight","90":"components-MultiTabList-MultiTabList","91":"components-QuickCarousel-QuickCarousel","92":"components-StickyBar-StickyBar","93":"components-all_feed-all_feed","94":"components-categories","95":"components-config-config","96":"components-editor_highlights-editor_highlights","97":"components-finite_scroll","98":"components-footer-footer","99":"components-franchise_intro-franchise_intro","100":"components-ibd_category-ibd_category","101":"components-image-image","102":"components-magazine_archive-magazine_archive","103":"components-masthead-masthead","104":"components-mcp_section-mcp_section","105":"components-mic_mobile_menu-mic_mobile_menu","106":"components-more-stories-component-more-stories-component","107":"components-newsletters-recaptcha","108":"components-notice","109":"components-piano-pianoBottomBanner","110":"components-podcast_tile-podcast_tile","111":"components-podcast_tile-podcast_tile_featured","112":"components-post-content-insert","113":"components-ranked","114":"components-recirc-recirc","115":"components-related_posts-related_posts","116":"components-related_slider-related_slider","117":"components-sectors_list-sectors_list","118":"components-social","119":"components-social-social","120":"components-top_50-top_50","121":"components-top_50_shuffle-top_50_shuffle","122":"components-video_megatron-video_megatron","123":"components-video_module-utils-video_module_ads","124":"components-video_module-video_module","125":"containers-pages-list_landers-bwi-2020","126":"containers-pages-list_landers-ibd-2020","127":"containers-pages-list_landers-mic-2021","128":"content-innovation_festival_banner","129":"content-sponsor_bar","130":"fc-components-main-components","131":"fc-components-main-components-StickyBar-StickyBar","132":"fc-components-main-containers","133":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","134":"fc-components-main-containers-IbdLayout-IbdLayout","135":"fc-components-main-containers-WciLayout-WciLayout","136":"fc-components-main-utils-ConditionalWrapper","137":"franchises-BtmApplyPage","138":"franchises-BwiApplyPage","139":"franchises-IbdApplyPage","140":"franchises-MicApplyPage","141":"franchises-NbttApplyPage","142":"franchises-WciApplyPage","143":"innovation_by_design_future_page","144":"innovation_by_design_page_franchise","145":"innovation_by_design_page_franchise_2023","146":"layouts","147":"layouts-mcp","148":"nav_main_menu-nav_main_menu","149":"package_article_list_entry","150":"packages-nav-package_sticky_nav","151":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"e69bf5863f565a8b355f","2":"9e527438ac9ef399c52a","3":"0b7ee359ddacee9a28b3","4":"2adf45095cad886bfef4","5":"b49ff406e37dc839fd98","6":"07b7f7a8bd82fc1b0c09","7":"d4f4ef65918b645d74a3","8":"db5c624eabcdfb9db47e","9":"4a8fe509e82ae76ab531","10":"68a1654c5f72b45a0f49","11":"09bf3077d3332706f515","12":"750080f334c579c8b9aa","13":"63ffdea9e04189dfabeb","14":"fc3c77158c117bea14df","15":"ee696f9ba7e71477d6c8","16":"76debaf824416bcd975b","17":"eea64a75a5312f6ab7bc","18":"8f3f750a70820925cfa8","19":"9a01f30f1f72ca13e3ad","20":"878a916862916a8273cc","21":"98fba14ae5067c8b004c","22":"83e466c6fad71fa367d3","23":"70ae16ba68d1bc852bf3","24":"8d82f586672b1ecad4fa","25":"63f6c0151db872c5c74c","26":"8bd016f3c8bcc53366ae","27":"dd9c5d980b86b2325493","28":"467b5f66e04a134f2988","29":"fc9ca4a54ba3d32959c9","30":"20efd31c20fc559ab502","31":"ef62067a256a0a3833f9","32":"65e2f8c8e26e5ff7984a","33":"908a2338f2e489dec175","34":"342abc91db22354936f1","35":"084c8154935db47c7f78","36":"3d2dc80ba0b774cdfc30","37":"2faf119e764027d446fe","38":"ebec54aa6d0696efed3f","39":"74c3967bdb8e6284bd83","40":"f362e328c98241fa9ee0","41":"a684ab7aef0c1bace7fd","42":"d5be2bf71ae984867327","43":"5429e728cf77f987f0da","44":"16ec268e2775a0ae51cf","45":"fab25792043a2ca6e120","46":"826ab94a251a69496f6f","47":"9f1ccf83b1bb24d8feef","48":"1833cbeb502c944a3056","49":"6b4d6a9d6f359d9e32b5","50":"5bf81365a60dad6f5b0a","51":"b6adf23210825b5a2868","52":"145523e25b88162c042e","53":"64086ebe5a6070d31c85","54":"0dd7017b55df4aa2620f","55":"d9d8a34353022c9f6987","56":"d5b6bb65de03c2b36dd3","57":"41d28bde273c061a9caa","58":"496b37d6775248424cfc","59":"884bf6ea76a37d2e6edf","60":"3b21d48b615fed921be5","61":"6776d6f9901a3e288032","62":"7df25c3f96b2f58ad0cc","63":"9e453fcc9834ed36cad4","64":"d30f8240b978b46b754d","65":"9b5aa6f16201a5a305af","66":"ac480d1d50d0d75a58ac","67":"71d900bea81041f58cfc","68":"f436b8db26fa33f86ae8","69":"ac748216ccb67cbff007","70":"fc58696ad43b18cbc8a2","71":"c2b48cdb46089e7e9554","72":"3561bfba7109d0ee0beb","73":"712e949bb2251a6247e3","74":"a5faeadccb07d18ffe1e","75":"fd83d6ca8001cb9861a3","76":"5f0fc57c5dd9c1459b43","77":"7a66b161996fbbdc9702","78":"77e14575e51260d6892e","79":"5f2c22b2a1b7208ac12b","80":"aa30ed2d40d2eeddcebf","81":"08a1f7c75bbc42d9f99d","82":"41d7ed00252d3012afee","83":"824346ed276daa54527a","85":"388c1bebe72dad85d3cd","86":"066ff0ddfc7b24b2fb74","87":"460aca876c080c284b85","88":"23c0996fd3686a04da71","89":"be0c456a6043c2d94551","90":"f733f276eeefa963347f","91":"62f5c38d77d6c8221e04","92":"644cc07f82cae2aac762","93":"b6531252f009a1717580","94":"a268d8b598e658b13e66","95":"dd4d9bbef008ddca18dd","96":"4406e9366985c6638d66","97":"a16de0ed1da502769949","98":"200a4572b51dc709db6c","99":"a9165255dc496fa880b8","100":"33ec5e1b5a426097e338","101":"15d135ee65427f28ead4","102":"8144f389743de15b0cf6","103":"9a3bfabd3e741929612f","104":"e9390b834d571099ac8a","105":"b80f47545fba846e09c7","106":"abcdc15748810234e368","107":"9af0edd77fe5b6d886ee","108":"9ae7f54308d0bf22620f","109":"345d22516f2836398811","110":"783a791fb96af6de2ca0","111":"a39bf1ab5cab842b28a1","112":"ccc0e6e7c072b5215185","113":"5dfe708af4608992e94c","114":"f417df53a645b2edd631","115":"a57b3727883e8713e358","116":"fbcd1e0fad0534f31d5b","117":"d9136b6843453170742b","118":"b7f124e642dc38a477c4","119":"fd61552e5511ea0c9591","120":"1f464a07dab1a0b1dc94","121":"fb16120d5e63ef894335","122":"1c68c012bb45121e3d02","123":"60f90691c936cb6d4311","124":"597f074a023c4f673a02","125":"23e3cdbf4fbc8896e0f5","126":"9b6c9076e24580b765cb","127":"3f572b7555669054822a","128":"3d85780380e184d0563a","129":"5a5e554344979bd814bf","130":"5a228db830b4c0ddd499","131":"61c5205a4a9f2bebfa0c","132":"50e35a433c0259b45492","133":"5beb3bd52209cfbe3b7a","134":"35d7c604ac7acbf7bc67","135":"c074a21d6453aa1508ff","136":"0f4ecaf4bdb6bc45fe72","137":"46f9db818a22a43e0b20","138":"dfe80df01168fc972796","139":"f58b23af67764e030b7a","140":"2dff97f70c44369cc5c6","141":"2ac7ac0b4e017093f0e6","142":"8a2cb77edcc4e9e61975","143":"e4eeccae56e0a9e19133","144":"a93483146e0cb60e31de","145":"d40841f013414a0bd4e4","146":"cf431c8c9b4e7fd98bab","147":"c8d551dc1e9f6725ddf2","148":"9d5a85f58b25e04c3412","149":"b883d699b069aa2f795b","150":"8f8ab106897106acf390","151":"9b6de601e1e35a77e845"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([742,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
